<template>
  <div class="page">
    <div class="container">
      <div class="tabs">
        <el-tabs v-model="tabs.value" @tab-click="handleClickTabs" center>
          <el-tab-pane v-for="item in tabs.list" :key="item.value" :label="item.label" :name="item.value">
            <!-- 入学测试 -->
            <template v-if="item.value === '1'">
              <div class="filter">
                <div class="filter-left">
                  <el-radio-group v-model="form1.showtype" size="small">
                    <el-radio-button :label="1">卡片</el-radio-button>
                    <el-radio-button :label="2">列表</el-radio-button>
                  </el-radio-group>
                </div>

                <div class="filter-left">
                  <el-radio-group v-model="form1.status" size="small" @input="changeStatus">
                    <el-radio-button :label="1">全部</el-radio-button>
                    <el-radio-button :label="2">未开始</el-radio-button>
                    <el-radio-button :label="3">进行中</el-radio-button>
                    <el-radio-button :label="4">已结束</el-radio-button>
                  </el-radio-group>
                </div>

                <div class="filter-right">
                  <el-form :model="form1" size="mini" :inline="true">
                    <el-form-item label="所属科目:" prop="subject_id">
                      <el-select v-model="form1.subject_id" placeholder="请选择" clearable>
                        <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="练习名称:" prop="title">
                      <el-input style="width: 200px" v-model="form1.exam_name" placeholder="请输入名称" clearable @keyup.enter.native="search"></el-input>
                    </el-form-item>
                    <!-- <el-form-item>
                      
                    </el-form-item> -->

                    <el-form-item>
                      <el-button class="search_btn" type="primary" size="mini" icon="el-icon-search" @click="search">
                        查询</el-button>

                      <el-button class="search_btn" type="primary" size="mini" icon="el-icon-edit" @click="CreatePractice" style="margin-right:10px;">布置练习
                      </el-button>
                      <el-checkbox v-model="form1.owned1" style="float: right;margin-left:20px" @change="search">我的练习</el-checkbox>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
            <template v-else-if="item.value === '2'">
              <div class="filter">
                <div class="filter-left">
                  <el-radio-group v-model="form1.showtype" size="small">
                    <el-radio-button :label="1">卡片</el-radio-button>
                    <el-radio-button :label="2">列表</el-radio-button>
                  </el-radio-group>
                </div>

                <div class="filter-left">
                  <el-radio-group v-model="form1.status" size="small" @input="changeStatus">
                    <el-radio-button :label="1">全部</el-radio-button>
                    <el-radio-button :label="2">未开始</el-radio-button>
                    <el-radio-button :label="3">进行中</el-radio-button>
                    <el-radio-button :label="4">已结束</el-radio-button>
                  </el-radio-group>
                </div>
                <div class="filter-right">
                  <el-form :model="form1" size="mini" :inline="true">
                    <el-form-item label="所属科目:" prop="subject_id">
                      <el-select v-model="form1.subject_id" placeholder="请选择" clearable>
                        <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="考试名称:" prop="title">
                      <el-input style="width: 200px" v-model="form1.exam_name" placeholder="请输入名称" clearable @keyup.enter.native="search"></el-input>
                    </el-form-item>
                    <!-- <el-form-item>
                      
                    </el-form-item> -->

                    <el-form-item>
                      <el-button class="search_btn" type="primary" size="mini" icon="el-icon-search" @click="search">
                        查询</el-button>

                      <el-button class="search_btn" type="primary" size="mini" icon="el-icon-edit" @click="CreateExam" style="margin-right:10px;">新增考试
                      </el-button>
                      <el-checkbox v-model="form1.owned2" style="float: right;margin-left:20px;" @change="search">我的考试</el-checkbox>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
            <template v-else-if="item.value === '3'">
              <div class="filter">
                <div class="filter-left">
                  <el-radio-group v-model="form1.showtype" size="small">
                    <el-radio-button :label="1">卡片</el-radio-button>
                    <el-radio-button :label="2">列表</el-radio-button>
                  </el-radio-group>
                </div>

                <!-- <div class="filter-left">
                  <el-radio-group v-model="form1.status" size="small" @input="changeStatus">
                    <el-radio-button :label="1">全部</el-radio-button>
                    <el-radio-button :label="2">未开始</el-radio-button>
                    <el-radio-button :label="3">进行中</el-radio-button>
                    <el-radio-button :label="4">已结束</el-radio-button>
                  </el-radio-group>
                </div> -->
                <div class="filter-right">
                  <el-form :model="form1" size="mini" :inline="true">
                    <!-- <el-form-item label="所属科目:" prop="subject_id">
                      <el-select v-model="form1.subject_id" placeholder="请选择" clearable>
                        <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index">
                        </el-option>
                      </el-select>
                    </el-form-item> -->

                    <el-form-item label="试卷名称:" prop="title">
                      <el-input style="width: 200px" v-model="form1.exam_name" placeholder="请输入试卷名称" clearable @keyup.enter.native="search"></el-input>
                    </el-form-item>
                    <!-- <el-form-item>
                      
                    </el-form-item> -->

                    <el-form-item>
                      <el-button class="search_btn" type="primary" size="mini" icon="el-icon-search" @click="search">
                        查询</el-button>

                      <el-button class="search_btn" type="primary" size="mini" icon="el-icon-edit" @click="CreatePaper" style="margin-right:10px;">新增试卷
                      </el-button>
                      <!-- <el-button class="search_btn" type="primary" size="mini" icon="el-icon-edit" @click="CreateExam" style="margin-right:10px;">新增考试
                      </el-button> -->
                      <!-- <el-checkbox v-model="form1.owned2" style="float: right;margin-left:20px;" @change="search">我的考试</el-checkbox> -->
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="content">
        <div class="block-list" v-if="tabs.value === '1'">
          <subunitPrictice v-if="examlist1.join('') !== ''" :pricticelist="examlist1" :showtype="form1.showtype" :page_no="page_no" :page_size="page_size" @methodEditPractice="EditPractice" @methodExamResult="ExamResult" @methodLookPractice="LookPractice" @methodaddExamStu="addExamStu" @methoddeleteExam="deleteExam" />
          <subunitEmpty v-else />
          <div class="pagination" v-if="examlist1.join('') !== ''">
            <div class="pagination-box">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" background :page-sizes="[20, 30, 40, 50]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
        <div class="block-list" v-else-if="tabs.value === '2'">
          <subunitExam v-if="examlist2.join('') !== ''" :examlist="examlist2" :showtype="form1.showtype" :page_no="page_no" :page_size="page_size" @methodCopyExam="CopyExam" @methodCollectExam="CollectExam" @methodEditExam="EditExam" @methodLookExam="LookExam" @methoddeleteExam="deleteExam" @methodExamResult="ExamResult" @methodaddExamStu="addExamStu" @methodEditQuestions="EditQuestions" />
          <subunitEmpty v-else />
          <div class="pagination" v-if="examlist2.join('') !== ''">
            <div class="pagination-box">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" background :page-sizes="[20, 30, 40, 50]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
        <div class="block-list" v-else-if="tabs.value === '3'">
          <subunitCollect v-if="examlist3.join('') !== ''" :examlist="examlist3" :showtype="form1.showtype" :page_no="page_no" :page_size="page_size" @methodCreateExam="CreateExam" @methodStartPractice="StartPractice" @methodStartExam="StartExam" @methodCopyExam="CopyExam" @methodCollectExam="CollectExam" @methodLookExam="LookExam" @methodPaperCopy="PaperCopy" @methoddeleteExam="deleteExam" @methodExamResult="ExamResult" @methodEditQuestions="EditQuestions" />
          <subunitEmpty v-else />
          <div class="pagination" v-if="examlist3.join('') !== ''">
            <div class="pagination-box">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" background :page-sizes="[20, 30, 40, 50]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="新增题库" :visible.sync="dialogVisible" width="40%">
      <el-form class="form-style" :model="form" size="mini" label-position="left">
        <el-form-item label="序号" required prop="sort_num">
          <el-input-number v-model="form.sort_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="所属科目" required prop="subject_id">
          <el-select v-model="form.subject_id" placeholder="请选择" clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="题库名称" required prop="title">
          <el-input v-model="form.title" placeholder="请输入名称"></el-input>
        </el-form-item>

        <el-form-item label="简介" required>
          <el-input type="textarea" v-model="form.desc" placeholder="请输入题库的简介"></el-input>
        </el-form-item>

        <el-form-item label="封面" required prop="img_url">
          <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="1" :file-list="form.imgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip">
              <span style="color: red">推荐尺寸(750*340)</span>
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import subunitPrictice from '../subunitComponents/subunitPrictice.vue'
import subunitExam from '../subunitComponents/subunitExam.vue'
import subunitCollect from '../subunitComponents/subunitCollect.vue'
import subunitEmpty from '../subunitComponents/subunitEmpty.vue'
import {
  getSchoolPracticeList,
  getSchoolExamList,
  getKeepPaperList,
  deleteExam,
  changeState,
  examCopyPaper,
  operateKeepPaper
} from '@/api/educational'
// import { api_editExamPostState } from '@/api/competitionCenter'  更改考试状态
import { getZoneSchoolSubjectList } from '@/api/community'
export default {
  // 练习/考试页面
  name: 'CompetitionCenter-PracticeAndExams',
  components: {
    subunitPrictice,
    subunitExam,
    subunitCollect,
    subunitEmpty,
  },
  data: () => ({
    tabs: {
      value: '1',
      list: [
        { label: '学员练习', value: '1' },
        { label: '学员考试', value: '2' },
        { label: '试卷收藏', value: '3' },
      ],
    },
    tableTitle: [
      { label: '练习名称', value: 'title', align: 'left', width: '200' },
      {
        label: '提交情况',
        value: 'submissionStatus',
        align: 'left',
        width: '',
      },
      { label: '开始时间', value: 'start_date', align: 'left', width: '' },
      { label: '结束时间', value: 'end_date', align: 'left', width: '' },
      { label: '创建人', value: 'realname', align: 'left', width: '100' },
      { label: '开启状态', value: 'post_state', align: 'center', width: '' },
    ],
    firstTime: true,
    form1: {
      subject_id: '',
      exam_name: '',
      owned1: true,
      owned2: true,
      status: 1,
      showtype: 1,
    },

    examlist1: [],
    examlist2: [],
    examlist3: [],

    form: {
      sort_num: 1,
      title: '',
      subject_id: '',
      desc: '',
      img_url: '',
      imgList: [],
    },
    subjectList: [],
    dialogVisible: false, //新增题库
    input: '',
    page_no: 1,
    page_size: 20,
    total: 0,

    title: '',
    value: true,
    post_state: false,
    post_state1: '',
    token: '',
  }),
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     console.log(from)
  //   })
  // },
  activated() {
    const practiceAndExamsTabVal = window.sessionStorage.getItem(
      'practiceAndExamsTabVal'
    )
    if (this.$route.query && this.$route.query.type) {
      this.tabs.value = this.$route.query.type === 'practice' ? '1' : this.$route.query.type === 'exam' ? '2' : '3'
    } else if (practiceAndExamsTabVal) {
      this.tabs.value = practiceAndExamsTabVal
    }
    if (this.firstTime === false) {
      this.tabs.value === '1'
        ? this.getSchoolPracticeList()
        : this.tabs.value === '2' ? this.getSchoolExamList()
          : this.getKeepPaperList();
    }
  },
  mounted() {
    const practiceAndExamsTabVal = window.sessionStorage.getItem(
      'practiceAndExamsTabVal'
    )
    if (this.$route.query && this.$route.query.type) {
      this.tabs.value = this.$route.query.type === 'practice' ? '1' : this.$route.query.type === 'exam' ? '2' : '3';
    } else if (practiceAndExamsTabVal) {
      this.tabs.value = practiceAndExamsTabVal
    }
    this.getZoneSchoolSubjectList()

    if (this.firstTime === true) {
      this.tabs.value === '1'
        ? this.getSchoolPracticeList()
        : this.tabs.value === '2' ? this.getSchoolExamList()
          : this.getKeepPaperList()
    }
    // this.getSchoolPracticeList();
  },
  methods: {
    handleClickTabs() {
      window.sessionStorage.setItem('practiceAndExamsTabVal', this.tabs.value)
      this.form1.status = 1
      this.form1.subject_id = ''
      this.form1.exam_name = ''
      this.search()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.search()
    },
    changeStatus() {
      this.search()
    },

    search() {
      this.page_no = 1
      this.tabs.value === '1'
        ? this.getSchoolPracticeList()
        : this.tabs.value === '2' ? this.getSchoolExamList()
          : this.getKeepPaperList()
    },

    open(row) {
      changeState({
        exam_id: row.id,
        post_state: 1,
      }).then((res) => {
        console.log(res)
        this.tabs.value === '1'
          ? this.getSchoolPracticeList()
          : this.tabs.value === '2' ? this.getSchoolExamList()
            : this.getKeepPaperList()
      })
    },
    close(row) {
      changeState({
        exam_id: row.id,
        post_state: 2,
      }).then((res) => {
        console.log(res)
        this.tabs.value === '1'
          ? this.getSchoolPracticeList()
          : this.tabs.value === '2' ? this.getSchoolExamList()
            : this.getKeepPaperList();
      })
    },

    getZoneSchoolSubjectList() {
      console.log('查询校区科目')

      getZoneSchoolSubjectList().then((res) => {
        console.log('校区科目')
        console.log(res)
        this.subjectList = res.subjectList
      })
    },

    getSchoolPracticeList() {
      getSchoolPracticeList({
        title: this.form1.exam_name,
        subject_id: this.form1.subject_id,
        isShowSelfPaper: this.form1.owned1, //是否只显示本人创建的试卷 true false
        search_user_id: '', //个人id
        page_no: this.page_no,
        page_size: this.page_size,
        date_state: this.form1.status,
      }).then((res) => {
        console.log('练习列表')
        console.log(res)
        this.examlist1 = res.examList
        this.total = res.total
        if (this.$route.query && this.$route.query.type) {
          const currentRoute = this.$route
          this.$router.replace({ ...currentRoute, query: {} })
        }
      })
    },
    getSchoolExamList() {
      getSchoolExamList({
        title: this.form1.exam_name,
        subject_id: this.form1.subject_id,
        isShowSelfPaper: this.form1.owned2, //是否只显示本人创建的试卷 true false
        search_user_id: '', //个人id
        page_no: this.page_no,
        page_size: this.page_size,
        date_state: this.form1.status,
      }).then((res) => {
        console.log('考试列表')
        console.log(res)
        res.examList.forEach((item) => {
          item.allowSubmit = true;
          item._lasttime = Number(item.lasttime / 60)
          const startTime = new Date(item.start_date),
            endTime = new Date(item.end_date),
            nowTime = Date.now()
          if (nowTime > startTime && nowTime < endTime) {
            item.examStatus = '进行中'
          } else if (nowTime > endTime) {
            item.examStatus = '已结束'
          } else if (nowTime < startTime) {
            item.examStatus = '未开始'
          }
        })
        this.examlist2 = res.examList
        this.total = res.total
        if (this.$route.query && this.$route.query.type) {
          const currentRoute = this.$route
          this.$router.replace({ ...currentRoute, query: {} })
        }
      })
    },
    getKeepPaperList() {
      getKeepPaperList({
        title: this.form1.exam_name,
        subject_id: this.form1.subject_id,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then(res => {
        console.log(res)
        this.examlist3 = res.paperList
        this.examlist3.forEach(item => {
          item.allowSubmit = true;
          item.test_paper_id = item.id;
          item.paperInfo = {
            "id": item.id,
            "subject_id": item.subject_id,
            "title": item.title,
            "total_num": item.total_num,
            "total_score": item.total_score,
            "educational_institution_id": item.educational_institution_id,
            "user_id": item.user_id,
            "created_time": item.created_time,
            "post_state": item.post_state,
            "content": item.content,
            "is_vaild": item.is_vaild,
            "questionBankIds": item.questionBankIds,
          }
        })
        this.total = res.total
        if (this.$route.query && this.$route.query.type) {
          const currentRoute = this.$route
          this.$router.replace({ ...currentRoute, query: {} })
        }
      })
    },
    deleteExam(id) {
      this.$confirm('删除后,学生的作答记录也一并会删除!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteExam({
          examId: id,
        }).then((res) => {
          console.log(`删除${this.tabs.value === '1' ? '练习' : '考试'}`)
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.tabs.value === '1'
              ? this.getSchoolPracticeList()
              : this.tabs.value === '2' ? this.getSchoolExamList()
                : this.getKeepPaperList();
          }
        })
      })
    },

    //添加试题
    AddQuestion(row) {
      console.log('添加试题')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-AddQuestion',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    // QuestionManagement(row) {
    //   console.log('试题管理--只查看')
    //   console.log(row)
    //   this.$router.push({
    //     name: 'CommonExam-Questionlist',
    //     query: {
    //       id: row.id,
    //       title: row.title,
    //     },
    //   })
    // },
    Practice(row) {
      console.log('练习')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-Practice',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    StartPractice(item) {
      this.firstTime = false
      console.log('创建练习', item)
      this.$router.push({
        name: 'CommonExam-CreatePractice',
        query: {
          id: item.id, // 题库ID
          // subject_id: item.subject_id, // 科目
          // bank_type: '1', // 类型 ''全部 '1'平台题库 '2'校区题库
          // source_id: item.source_id, // 题库来源
          // bank_name: item.title, // 题库名称
          papername: item.title,
          subject_id: item.subject_id, // 科目ID
          paperId: item.id
        },
      })
    },
    StartExam(row) {
      this.firstTime = false
      console.log('发起考试：', row)
      this.$router.push({
        name: 'CommonExam-StartExam',
        query: {
          id: row.id,
          subject_id: row.subject_id,
          total_num: row.total_num,
          total_score: row.total_score,
        },
      })
    },
    CreatePaper() {
      this.firstTime = false
      console.log('创建考试')
      this.$router.push({
        name: 'CommonExam-CreatePaper',
        query: {
          collect: true
        }
      })
    },
    EditExam(row) {
      this.firstTime = false
      console.log('编辑考试')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-EditExam',
        query: {
          title: row.title,
          id: row.id,
        },
        params: {
          examinfo: row,
        },
      })
    },

    LookExam(row) {
      console.log('查看考试')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-PaperDetail',
        query: {
          id: row.paperInfo.id,
          title: row.title,
        },
      })
    },
    addExamStu(row) {
      this.firstTime = false
      console.log('练习学员编辑 / 考生编辑')
      this.$router.push({
        name:
          this.tabs.value === '1'
            ? 'CommonExam-EditPracticestu'
            : 'CommonExam-EditExamstu',
        query: {
          title: row.title,
          id: row.id,
          subject_id: row.subject_id,
        },
        params: {
          examClassArr: row.examClassArr,
          examCampusArr: row.examCampusArr,
        },
      })
    },

    CreatePractice() {
      this.firstTime = false
      console.log('创建练习')
      this.$router.push({
        name: 'CommonExam-CreatePractice',
      })
    },

    CreateExam() {
      this.firstTime = false
      console.log('创建考试')
      this.$router.push({
        name: 'CommonExam-CreateExam',
      })
    },
    CopyExam(item) {
      this.firstTime = false
      console.log('创建考试')
      this.$router.push({
        name: 'CommonExam-CreateExam',
        query: {
          examInfo: item,
        },
      })
    },
    CollectExam(item, key = '') {
      item.allowSubmit = false;
      let operate = item.isKept ? 2 : 1
      if (key === 'update') {
        operate = 2;
      }
      operateKeepPaper({
        paperId: item.test_paper_id,
        operate,
      }).then(res => {
        console.log(res)
        item.isKept = !item.isKept
        item.allowSubmit = true;
        if (res.is_create) {
          this.$message.success('收藏试卷成功');
        }
        if (res.is_delete) {
          this.$message.warning('已取消收藏试卷');
        }
        if (key === 'update') {
          this.getKeepPaperList();
        }
      }).catch(err => {
        item.allowSubmit = true;
        console.log(err)
      })
      window.log.warning(item.isKept)
    },
    EditPractice(row) {
      this.firstTime = false

      console.log('编辑练习')
      this.$router.push({
        name: 'CommonExam-EditPractice',
        query: {
          title: row.title,
        },
        params: {
          practiceInfo: row,
        },
      })
    },

    ExamResult(row) {
      this.firstTime = false

      console.log('练习成绩统计')
      this.$router.push({
        name:
          this.tabs.value === '1'
            ? 'CommonExam-PracticeResult'
            : 'CommonExam-ExamResult',
        query: {
          id: row.id,
          title: row.title,
          passscore: row.passscore,
        },
      })
    },

    LookPractice(row) {
      this.firstTime = false

      console.log('查看练习')
      console.log(row)

      this.$router.push({
        name: 'CommonExam-PracticeDetail',
        // query: { id: row.question_bank_id, title: row.title },
        query: { id: row.id },
      })
    },

    EditQuestions(row) {
      console.log('编辑试题')
      console.log(row)
      this.firstTime = false
      this.$router.push({
        name: 'CommonExam-EditQuestions',
        query: {
          id: row.paperInfo.id,
          title: row.title,
          bank_ids: row.paperInfo.questionBankIds,
        },
      })
    },
    PaperCopy(id) {
      this.$prompt('请输入试卷副本的名称?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          if (value) {
            this.copyPaper(id, value)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消',
          })
        })
    },

    copyPaper(id, value) {
      examCopyPaper({
        paper_id: id,
        paper_title: value,
      }).then((res) => {
        console.log('复制试卷')
        console.log(res)
        if (res.is_create) {
          this.$message.success('试卷拷贝成功')
          this.tabs.value === '1'
            ? this.getSchoolPracticeList()
            : this.tabs.value === '2' ? this.getSchoolExamList()
              : this.getKeepPaperList();
        }
      })
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.tabs.value === '1'
        ? this.getSchoolPracticeList()
        : this.getSchoolExamList()
    },
    handleChangeFile() { },
    handleRemove() { },
    uploadFile() { },
  },
}
</script>
<style scoped lang="scss">
.page {
  padding: 10px;
  .container {
    max-width: 1680px;
    margin: auto;
    .tabs {
      padding-top: 10px;
      margin-bottom: 20px;
      border-radius: 5px;
      background-color: #fff;
      /deep/ .el-tabs {
        .el-tabs__header {
          position: initial;
          margin: 0 0 10px;
          .el-tabs__nav-wrap {
            padding-left: 28px;
            .el-tabs__nav-scroll {
              display: block;
              .el-tabs__nav {
                .el-tabs__item {
                  font-size: 16px;
                }
              }
            }
          }
        }
        .el-tabs__content {
          .filter {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 0 20px;
            .filter-left {
              flex-shrink: 0;
              padding-bottom: 8px;
              // height: 57px;
              // padding-top: 5px;
            }
          }
        }
      }
      .el-radio-group /deep/ {
        .el-radio-button.is-active {
          .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            background-color: #fff;
            color: #409eff;
          }
        }
      }
      .el-form {
        .el-form-item {
          margin-bottom: 12px;
          /deep/ .el-form-item__content {
          }
        }
      }
    }
    .content {
      .table {
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
        .pagination {
          padding-top: 20px;
          text-align: right;
          z-index: 1999 !important;
        }
      }
      .el-dropdown-link {
        cursor: pointer;
        color: #409eff;
        font-size: 12px;
        padding-right: 5px;
        padding-left: 10px;
      }
      .block-list {
        padding-bottom: 90px;
        .pagination {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background: rgba(255, 255, 255, 0.95);
          box-shadow: inset 1px 1px 0px 0px #ebedf0;
          z-index: 1999 !important;
          .pagination-box {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            max-width: 1680px;
            height: 70px;
            padding: 0 50px;
            margin: auto;
          }
        }
      }
    }
  }
}
</style>
